module.exports = __webpack_public_path__ + "static/optimo-zaleta-9-add7089eecbb7eecdc431fc37ec8070c.png";